import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import CheckTable from "./CheckTable"; //reused table component
import CheckAddItem from "./CheckAddItem"; //reused modal component
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import numeral from "numeral";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const CashVoucherAllocateExpenses = () => {
	const { cvno } = useParams();
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [purchaseType, setPurchaseType] = useState([]);
	const [supplier, setSupplier] = useState([]);
	const [glAccounts, setGlAccounts] = useState([]);
	const [supplierId, setSupplierId] = useState([]);
	const [reference, setReference] = useState('');

	const [cvDetails, setCvDetails] = useState([]);

	const classes = useStyles();
	const [poTotal, setPoTotal] = useState(0);

	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	let history = useHistory();
	const [items, setItems] = useState([]); //data to display in table

	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.amount))
		setPoTotal(po_total);
		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);

	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};

	const x = 0;
	useEffect(() => { //
		getCVDetails();
		isLoggedIn();
		getGlAccountList();
	}, [x]);

	const getCVDetails = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'cv_allocate_expenses', {
			params:{
				cvno:cvno,
				jc_u_idno:branchIdNo,
			}
		}).then((res)=>{
			
			setCvDetails(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
	}
	const getGlAccountList = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/gl_accounts_list', {
					params:{
				branch:get_cookies("branchidno"),
			}
		}).then((res)=>{
			setGlAccounts(res.data[0]);
		}).catch((error)=>{
			// console.log(error.message);
		});
	}
	
	const addItem = (item) => {
			//add new unique item to array
			if(item.amount > cvDetails.amount_num){
				setShowMsgBox(true);
			setMsg("ERROR: Amount exceeded Cash Voucher total amount. Please allocate the total amount of Cash Voucher.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2500)
			}else{
				setItems([...items, 
					{
					id: item.id, 
					date: item.date,
					description: item.description, 
					amount: item.amount,
					gl_account: item.gl_account,
					gl_account_id: item.gl_id
					}
				]);
			}
	}	
	const deleteItem = (id) => {
		//console.log(id);
		let itemArray = items.filter(item => item.id != id);
		setItems(itemArray);
	}

// item_array:
// jc_uname:postmanapi
// jc_u_idno:DAVAOHQ
// supid:3
// refno:9999
// checktype:Purchases
// notes:api save check
// trandate:2021-03-15

const allocate_cv_expenses = async () => {
	if(poTotal !== cvDetails.amount_num){
			setShowModal(false); //hide loading/please wait modal 
			setShowMsgBox(true);
			setMsg("ERROR: Total amount has not been fully allocated. Please allocate the total amount of Cash Voucher.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
// item_array:
// jc_uname:mdbabaylan
// jc_u_idno:DAVAOHQ
// cvno:3046
	}else{
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(items));
		formData.append("jc_uname", get_cookies('username'));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("cvno", cvno);
	
		await axios.post(process.env.REACT_APP_API_URL+'allocate_cv_expenses', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Cash Voucher Allocation Success");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					// history.push('/account/cash-voucher-transaction-history');
					history.push(`/account/cash-voucher-view-allocated/${cvno}/${branchIdNo}`);
				}, 2000)
			  }).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
			  });
	}
}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<NavLink to={"/account"}><h2 style={{color:"black"}}>Accounts</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/account/cash-voucher-transaction-history"}><h2 style={{color:"black"}}>Cash Voucher Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Cash Voucher Allocate  #{cvno} (Expenses)</h2>
			</div>
			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
				<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Cash Voucher Information
								</div>
								<div className={classes.title}>
								Cash Voucher Information
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
								<CheckAddItem addItem={addItem} glAccounts={glAccounts}/>
							</Grid>
							</Grid>
				</div>
				<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Title: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{cvDetails.title || "Allocate Cash Voucher"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{cvDetails.date || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Pay To:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{cvDetails.payto || "Pay To"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Funds From:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{cvDetails.fundsfrom || "Funds From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Amount:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{cvDetails.amount || "Amount"}
								</Grid>
							</Grid>
						</div>	
					<CardContent>
						<CheckTable items={items} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(poTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
					</CardContent>
				</Card>
					<br/>					
					<div className={classes.buttonContainer}>
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{allocate_cv_expenses()}}>
					{/* <Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{console.log('klak')}}> */}
						Allocate to Expenses
					</Button>
					</div>
				</div>
			</div>
	);
};

export default CashVoucherAllocateExpenses;
